// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.is-active {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.modal-background {
  background: #1d1c1c;
}

.modal-card {
  background: #1d1c1c;
  color: #fffafa;
  display: flex;
  justify-content: center;
  width: 300px;
  text-align: start;
  flex-direction: column;
  border: 1px solid #797979;
  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  margin: calc(0% + 4%) calc(50% - 5%) 0 calc(25% + 12.5%);
}
@media (width < 1200px) {
  .modal-card {
    margin: calc(0% + 4%) calc(50% - 20%) 0 calc(25% + 10.5%);
  }
}
.modal-card-head {
  margin-bottom: 5%;
  color: #fffafa;
  padding: 20px 20px 0px 20px;
  text-align: center;
  font-family: Ubuntu;
  font-size: 22px;
  /* border-bottom: 2px solid #797979; */
  font-weight: 600;
  line-height: normal;
  letter-spacing: 1.5px;
}

.modal-card-body {
  display: flex;
  justify-content: center;

  text-align: center;
  flex-direction: column;
  font-size: 18px;
  padding: 0px 0px 20px 0px;
}

.delete {
  color: #fffafa;
  margin: 0 30% 5%;
  border-radius: 5px;
  outline: none;
  border: none;
  text-align: center;
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.7px;
  padding: 0.4rem 2.7rem;
  background-color: #991414;
}
.delete:hover:not(:active) {
  box-shadow: 4px 4px 2px #0000008e;
  font-size: 15px;
}
.delete:hover,
.delete:not(:focus),
.delete:not(:active) {
  outline: none;
  border: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/modal-window/modal.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,+CAA+C;EAC/C,mBAAmB;EACnB,wDAAwD;AAC1D;AACA;EACE;IACE,yDAAyD;EAC3D;AACF;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;;EAEvB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;;;EAGE,aAAa;EACb,YAAY;AACd","sourcesContent":[".is-active {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal-background {\n  background: #1d1c1c;\n}\n\n.modal-card {\n  background: #1d1c1c;\n  color: #fffafa;\n  display: flex;\n  justify-content: center;\n  width: 300px;\n  text-align: start;\n  flex-direction: column;\n  border: 1px solid #797979;\n  box-shadow: 0px 8px 8px 2px rgba(0, 0, 0, 0.25);\n  border-radius: 10px;\n  margin: calc(0% + 4%) calc(50% - 5%) 0 calc(25% + 12.5%);\n}\n@media (width < 1200px) {\n  .modal-card {\n    margin: calc(0% + 4%) calc(50% - 20%) 0 calc(25% + 10.5%);\n  }\n}\n.modal-card-head {\n  margin-bottom: 5%;\n  color: #fffafa;\n  padding: 20px 20px 0px 20px;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 22px;\n  /* border-bottom: 2px solid #797979; */\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 1.5px;\n}\n\n.modal-card-body {\n  display: flex;\n  justify-content: center;\n\n  text-align: center;\n  flex-direction: column;\n  font-size: 18px;\n  padding: 0px 0px 20px 0px;\n}\n\n.delete {\n  color: #fffafa;\n  margin: 0 30% 5%;\n  border-radius: 5px;\n  outline: none;\n  border: none;\n  text-align: center;\n  font-family: Ubuntu;\n  font-size: 14px;\n  font-weight: 400;\n  letter-spacing: 0.7px;\n  padding: 0.4rem 2.7rem;\n  background-color: #991414;\n}\n.delete:hover:not(:active) {\n  box-shadow: 4px 4px 2px #0000008e;\n  font-size: 15px;\n}\n.delete:hover,\n.delete:not(:focus),\n.delete:not(:active) {\n  outline: none;\n  border: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
